import { createSelector } from 'reselect'

const getPrivateLibraryCurrent = state => state.libraries.current

const myLibraryAddLessonToPrivateLibrary = createSelector(
	[getPrivateLibraryCurrent],
	privateLibraryCurrent => ({
		folders: privateLibraryCurrent.folders,
		parentFolderId: privateLibraryCurrent.folderUID !== '0' && privateLibraryCurrent.parents.length ?
			privateLibraryCurrent.parents[privateLibraryCurrent.parents.length - 1].id : null,
		currentFolderName: privateLibraryCurrent.name,
	})
)

export default myLibraryAddLessonToPrivateLibrary
